// extracted by css-extract-rspack-plugin
export default {"linkButton":"LinkButton-module__linkButton__JN9f0Tw"};